import { render, staticRenderFns } from "./WithPagination.vue?vue&type=template&id=67c602d8"
import script from "./WithPagination.vue?vue&type=script&lang=js"
export * from "./WithPagination.vue?vue&type=script&lang=js"
import style0 from "./WithPagination.vue?vue&type=style&index=0&id=67c602d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports